import { NgModule } from '@angular/core';
import { StaticFormDataService } from './static-form-data.service';
import { StaticFormLanguageService } from './static-form-language.service';
import { StaticFormChartTranslationService } from './static-form-chart-translation.service';
import { MultiTranslateHttpLoader } from '../common/multi-translate-http-loader/multi-translate-http-loader';

@NgModule({
  providers: [StaticFormLanguageService, StaticFormDataService, StaticFormChartTranslationService, MultiTranslateHttpLoader]
})
export class StaticFormServiceModule {}
